import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import {required} from '@vuelidate/validators';

const max10Characters = (data) => {
  if (data) {
    return data.length <= 10;
  }
  return true;
};

export default class UnitAlias extends BaseModel {
  constructor({id, number, unit, locale, no = undefined}) {
    super(id, number || no, unit);
    this.unit = unit;
    this.locale = locale;
  }

  static get fkName() {
    return 'unit_id';
  }
  static get apiRoute() {
    return 'unit_alias';
  }
  static get listPageRoute() {
    return null;
  }
  static get detailPageRoute() {
    return null;
  }
  static get createInitColumns() {
    return {};
  }
  get fkName() {
    return UnitAlias.fkName;
  }
  get apiRoute() {
    return UnitAlias.apiRoute;
  }
  get detailPageRoute() {
    return UnitAlias.detailPageRoute;
  }
  get listPageRoute() {
    return UnitAlias.listPageRoute;
  }
  get createInitColumns() {
    return UnitAlias.createInitColumns;
  }

  static get listDisplayAttrs() {
    return this.getAttributes(['number', 'unit']);
  }

  static get allAttributes() {
    return [
      this.NUMBER_ATTRIBUTE(),
      new AT.StringAttribute({
        name: 'unit',
        column: 'unit',
        validations: {required, max10Characters},
        tableProperties: {
          header: 'hit-base.common.unit',
          maxWidth: '1fr',
        },
      }),
      new AT.StringAttribute({
        name: 'locale',
        column: 'locale',
      }),
    ];
  }
}
